export const SELECT_ALL_ITEM_KEY = "__select_all__";

function isSelectAllKey(key: string): boolean {
  return key.startsWith("__select_all");
}

export type MultiSelectChange =
  | { type: "ignore" }
  | { type: "apply"; keys: string[] };

/**
 * Interprets a HeroUI multiple-select change event value (comma-joined keys).
 *
 * The "select all" row is owned by its own onPress handler. HeroUI still emits
 * a selection change for that press carrying the pre-press keys; applying it
 * would overwrite the toggle result, so those events resolve to `ignore` and
 * are left to the select-all handler. Every other change resolves to `apply`
 * with the parsed keys (an empty value clears the selection).
 */
export function resolveMultiSelectChange(rawValue: string): MultiSelectChange {
  const keys = rawValue === "" ? [] : rawValue.split(",");

  if (keys.some(isSelectAllKey)) {
    return { type: "ignore" };
  }

  return { type: "apply", keys };
}
